module.exports = __webpack_public_path__ + "static/media/google_developers.2198fcae.png";